var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-hidden": "true",
    "aria-label": "Clock icon",
    width: 74,
    height: 44,
    viewBox: "0 0 74 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 3,
    x: 13,
    y: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 3,
    x: 13,
    y: 38,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 4,
    y: 29,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 4,
    y: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 3,
    x: 10,
    y: 20,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M52 0C39.847 0 30 9.847 30 22s9.847 22 22 22 22-9.847 22-22S64.153 0 52 0zm19.161 22c0 10.53-8.525 19.161-19.161 19.161-10.53 0-19.161-8.525-19.161-19.161 0-10.53 8.525-19.161 19.161-19.161 10.53 0 19.161 8.525 19.161 19.161zm-13.209 7.833L50.75 24.6c-.275-.204-.434-.523-.434-.86V9.58c0-.586.479-1.065 1.064-1.065h1.242c.585 0 1.064.48 1.064 1.065v12.978l6.255 4.55c.479.347.576 1.012.23 1.491l-.727 1.002c-.346.47-1.012.577-1.49.231z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.af3e6a1d5ed1ec5fee29e24b2dbba13f.svg";
export { ForwardRef as ReactComponent };